const isServerSide = (function serverSideCheck() {
  try {
    return typeof window === 'undefined';
  } catch (e) {
    return true;
  }
})();

export default isServerSide;
